import { ApplicantsSortCols, IApplicantsFilter, Stage } from "Components/Applicants/ApplicantsModel";
import { ILabelValueBase, ITableHeadersBase } from "shared/SharedModels";

export const ApplicantsHeaders: ITableHeadersBase<ApplicantsSortCols>[] = [
    { columName: 'first_name', label: 'Name' },
    { columName: 'created_at', label: 'Date' },
    { columName: 'rating', label: 'Rating' }
];

export const ApplicantStages: ILabelValueBase<string, Lowercase<Stage>>[] = [
    { label: 'New', value: 'new' },
    { label: 'Offer', value: 'offer' },
    { label: 'Hired', value: 'hired' },
    { label: 'Second Interview', value: 'second_interview' },
    { label: 'Auto Rejected', value: 'auto_rejected' },
    { label: 'Phone Screening', value: 'phone_screening' },
    { label: 'Rejected', value: 'rejected' },
    { label: 'Interview', value: 'interview' },
    { label: 'Not qualified', value: 'not_qualified' },
    { label: 'Reviewed', value: 'reviewed' }
];

export const ApplicantsFiltersMap: IApplicantsFilter = {
    stages: [
        { label: 'Reviewed', value: 'reviewed' },
        { label: 'Not qualified', value: 'not_qualified' },
        { label: 'Phone Screening', value: 'phone_screening' },
        { label: 'Interview', value: 'interview' },
        { label: 'Second Interview', value: 'second_interview' },
        { label: 'Rejected', value: 'rejected' },
        { label: 'Hired', value: 'hired' },
    ],
    fit: [
        { label: 'Strong', value: 'strong' },
        { label: 'Fit', value: 'match' },
        { label: 'Weak', value: 'none' },
        { label: 'Distortion', value: 'distortion' },
    ],
    keywords: [
        { label: 'Sales', value: 'sales' },
        { label: 'Business', value: 'business' },
        { label: 'Marketing', value: 'marketing' },
        { label: 'Management', value: 'management' },
        { label: 'Customer', value: 'customer' },
    ],
    rating: [
        { label: 'FIVE', value: '5' },
        { label: 'FOUR', value: '4' },
        { label: 'THREE', value: '3' },
        { label: 'TWO', value: '2' },
        { label: 'ONE', value: '1' },
    ]
};

export const SkillMap = {
    FIVE: 5,
    FOUR: 4,
    THREE: 3,
    TWO: 2,
    ONE: 1
};

//Prepare Applicants headers with generic ILabelValueBase and add order property to sort the headers.
export const ApplicantsExcelHeaders: (ILabelValueBase & { order: number })[] = [
    { label: 'Application Completed At', value: "applicationCompletedAt", order: 7 },
    { label: 'Candidate Employer Job Id', value: "candidateEmployerJobId", order: 5 },
    { label: 'Candidate Id', value: "candidateId", order: 4 },
    { label: 'Comment  Total', value: "commentTotal", order: 11 },
    { label: 'Distortion Count', value: "distortionCount", order: 10 },
    { label: 'Email', value: "email", order: 3 },
    { label: 'Employer Job Id', value: "employerJobId", order: 6 },
    { label: 'First Name', value: "firstName", order: 1 },
    { label: 'Last Name', value: "lastName", order: 2 },
    { label: 'Match Type', value: "matchType", order: 9 },
    { label: 'Rating', value: "rating", order: 8 }
];

export const MatchTypes = {
    strong: 'strong',
    match: 'match',
    none: 'none',
    distortion: 'distortion'
};